export default __webpack_public_path__ + "static/media/Main-Page-Chart.c8dde93a.png";